export default function description() {
    return (
        <div className="card__description-basic">
            <div className="card__description">
                <p className="card__description-title">
                    Загальна характеристика
                </p>
                <p className="card__description-text">
                    ПЕГАС (НС 6341) — це потужний, витривалий гібрид соняшнику з високим потенціалом урожайності, який ідеально підходить для вирощування в умовах нестабільного зволоження. Гібрид створений для аграріїв, які прагнуть отримати максимум навіть у складних кліматичних умовах.
                </p>
                <p className="card__description-text">
                    Завдяки технології Clearfield®, ПЕГАС забезпечує ефективний контроль бур’янів, а також демонструє стабільні результати навіть при підвищеному гербіцидному навантаженні.
                </p>
                <p className="card__description-title">Основні переваги</p>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Потенціал урожайності — до 5,5 т/га</li>
                    <li className="card__description-numbering">Висока посухостійкість</li>
                    <li className="card__description-numbering">Стабільний та витривалий гібрид</li>
                    <li className="card__description-numbering">Стійкість до вовчка — 5 рас (A–E)</li>
                    <li className="card__description-numbering">Висока адаптивність до різних зон вирощування</li>
                    <li className="card__description-numbering">Добра реакція на інтенсивну технологію</li>
                </ol>
                <table className="card__description__table">
                    <tr>
                        <td className="card__description__td">Період вегетації</td>
                        <td className="card__description__th-index">107–112 днів</td>
                    </tr>
                    <tr>
                        <td className="card__description__td">Олійність:</td>
                        <td className="card__description__th-index">48–50%</td>
                    </tr>
                    <tr>
                        <td className="card__description__td card__description__td--link">Висота рослин</td>
                        <td className="card__description__th-index">170–190 см</td>
                    </tr>
                </table>
                <p className="card__description-title">
                    Рекомендації по густоті
                </p>
                <ol className="card__description-list">
                    <li className="card__description-numbering">За достатнього зволоження: 58–63 тис. рослин/га</li>
                    <li className="card__description-numbering">У посушливих умовах: 48–53 тис. рослин/га</li>
                </ol>
                <div className="card__description-title">Стійкість та толерантність</div>
                <ol className="card__description-list">
                    <p className="card__description-text">
                        Стійкість:
                    </p>
                    <li className="card__description-numbering">Посухостійкість, осипання — 9/10</li>
                    <li className="card__description-numbering">Холодостійкість, вилягання — 8/10</li>
                    <p className="card__description-text">
                        Толерантність до хвороб:
                    </p>
                    <li className="card__description-numbering">Іржа, біла та сіра гнилі — 9/10</li>
                    <li className="card__description-numbering">Вугільна гниль, септоріоз, фомопсис, пероноспороз, фомоз — 8/10</li>
                    <li className="card__description-numbering">Альтернаріоз — 7/10</li>
                </ol>
                <div className="card__description-title">Рекомендовані зони вирощування</div>
                <p className="card__description-text">
                    Гібрид найкраще реалізує свій потенціал у Степу та Лісостепу України, особливо в регіонах з дефіцитом вологи. Також можливе вирощування в більш ризикованих умовах за дотримання технології.
                </p>
                <div className="card__description-title">Рекомендації щодо вирощування</div>
                <p className="card__description-text">
                    ПЕГАС — це гібрид, який добре переносить стреси та показує стабільний результат навіть за мінімальних ресурсів. Рекомендується застосування гербіцидів системи Clearfield® (зокрема Євро-Лайтнінг) для ефективного контролю бур’янів.
                </p>
                <p className="card__description-text">
                    Гібрид добре реагує на підвищений агрофон, але особливо цінується за свою стабільність у посушливих умовах.
                </p>
                <p className="card__description-text">
                    ПЕГАС — це вибір для тих, хто хоче максимальну стабільність і врожай навіть у складних умовах. Ідеальний варіант для господарств у зоні ризикованого землеробства, де ключовим фактором є посухостійкість і витривалість.
                </p>
            </div>
            <div className="card__description-preference">
                <div className="aside__title--new">Головні переваги</div>
                <div className="asede__head">
                    <div className="aside__block">Високий потенція урожайності</div>
                    <div className="aside__block">Найкращу віддачу забезпечує на родючих грунтах</div>
                    <div className="aside__block">Один із найбільш високоврожайних гібридів з високим вмістом олії</div>
                </div>
            </div>
        </div>
    );
}
